$(document).ready(function(){
	
  if(document.querySelector('ap-badge')){
  document.querySelector('ap-badge').shadowRoot.querySelector('a img').setAttribute('style', 'width:150px');
  }
  
  
  AOS.init({
   once: true,   
  });

  const GREEN_ARROW_RIGHT = '<div class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0053/3993/8880/files/l-arrow-m3.svg" alt="Move slider one right to next"/></div>'
  const GREEN_ARROW_LEFT = '<div class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0053/3993/8880/files/right-arrow-m3.svg" alt="Move slider one left to previous"/></div>'

  const WHITE_ARROW_RIGHT = '<div class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0053/3993/8880/files/l-arrow-white.svg?v=1615256803" alt="Move slider one right to next"/></div>'
  const WHITE_ARROW_LEFT = '<div class=" slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0053/3993/8880/files/w-arrow-right.svg?v=1615256803" alt="Move slider one left to previous"/></div>'


  $('.product-offer__slider .main-slider').slick({
      asNavFor: $('.product-offer__slider .nav-slider'),
      fade: true
  }) 
  $('.product-offer__slider .nav-slider').slick({
      asNavFor: $('.product-offer__slider .main-slider'),
      slidesToShow: 6,
      centerMode: false,
      focusOnSelect: true,
      prevArrow: GREEN_ARROW_RIGHT,
      nextArrow: GREEN_ARROW_LEFT,
      swipeToSlide: true
  })
   // Slider for static pages
   $('#shopify-section-m3-usp-slider .usp-slider__slider ').slick({
      // the 'SlidesToShow' is not given as a data property so does need declared here.
      slidesToShow: 4,
      prevArrow: GREEN_ARROW_RIGHT,
      nextArrow: GREEN_ARROW_LEFT,
      swipeToSlide: true,
      autoplay:true,
      responsive: [
          {
              breakpoint:480,
              settings: {
                  slidesToShow: 1,
              }
          }
      ]
  })
  // Slider for static pages
  $('#m3-landing .usp-slider__slider').slick({
      // the 'SlidesToShow' is not given as a data property so does need declared here.
      slidesToShow: 3,
      prevArrow: WHITE_ARROW_RIGHT,
      nextArrow: WHITE_ARROW_LEFT,
      swipeToSlide: true,
      autoplay:true,
      responsive: [
          {
              breakpoint:480,
              settings: {
                  slidesToShow: 1,
              }
          }
      ]
  })
  // Slider for dynamic #ProductLanding page. 
  $('#ProductLanding .usp-slider__slider').slick({
      // the 'SlidesToShow' is given as a data property so no need to be declared here.
      // slidesToShow: 3,
      prevArrow: GREEN_ARROW_RIGHT,
      nextArrow: GREEN_ARROW_LEFT,
      swipeToSlide: true,
      autoplay:true,
      responsive: [
          {
              breakpoint:480,
              settings: {
                  slidesToShow: 1,
              }
          }
      ]
  })
  $('.featured-products__slider').slick({
      slidesToShow: 3,
      prevArrow: GREEN_ARROW_RIGHT,
      nextArrow: GREEN_ARROW_LEFT,
      swipeToSlide: true,
      responsive: [
          {
              breakpoint:480,
              settings: {
                  slidesToShow: 1,
              }
          }
      ]
  })
  // Slider on Product template
  $('.trusted__slider').slick({
      slidesToShow: 4,
      prevArrow: GREEN_ARROW_RIGHT,
      nextArrow: GREEN_ARROW_LEFT,
      swipeToSlide: true,
      responsive: [
          {
              breakpoint:480,
              settings: {
                  slidesToShow: 2,
              }
          }
      ]
  })
  // Slider on Landing Location template
  $('.trusted-by__slider').slick({
      slidesToShow: 4,
      prevArrow: GREEN_ARROW_RIGHT,
      nextArrow: GREEN_ARROW_LEFT,
      autoplay: true,
      autoplaySpeed: 2500,
      swipeToSlide: true,
      responsive: [
          {
              breakpoint:480,
              settings: {
                  slidesToShow: 2,
              }
          }
      ]
  })

  /* Partners Slider - Static on mobile */
  $('.m3-partners__inner[data-slider]').slick({
      slidesToShow: 7,
      // prevArrow: GREEN_ARROW_RIGHT,
      // nextArrow: GREEN_ARROW_LEFT,
      autoplay: false,
      responsive: [
          {
              breakpoint: 960,
              settings: {
                  slidesToShow: 4,
                  autoplay: true,
                  autoplaySpeed: 3000,
                  swipeToSlide: true,
              }
          },
          {
              breakpoint: 600,
              settings: {
                  slidesToShow: 3,
                  autoplay: true,
                  autoplaySpeed: 3000,
                  swipeToSlide: true,
              }
          }
      ]
  });

  $('.m3-partners__text[data-slider]').slick({
      slidesToShow: 4,
      autoplay: false,
      responsive: [
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 1,
                  autoplay: true,
                  autoplaySpeed: 3000,
                  swipeToSlide: true,
              }
          }
      ]
  });



  $('.treatment__slider').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: GREEN_ARROW_RIGHT,
      nextArrow: GREEN_ARROW_LEFT,
      swipeToSlide: true,
      responsive: [
          {
              breakpoint:900,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3
              }
          },
          {
              breakpoint:480,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
              }
          }
      ]
  })

  $('#reviews.grid-videos-pain-point').slick({
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        mobileFirst: true,
        arrows: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 768,
                settings: 'unslick'
            }
        ]
    });

  $('.experts__slider, .testimonial__slider').slick({
      slidesToShow: 1,
      prevArrow: GREEN_ARROW_RIGHT,
      nextArrow: GREEN_ARROW_LEFT,
  })
  $('.accordion__item .heading').on('click', function(){
      var accordion = $(this).closest('.accordion')
      
      if(!$(this).hasClass('open')){
          var current_option = accordion.find(".heading.open")
          current_option.removeClass('open')
          current_option.siblings('.body').slideUp()
          $(this).addClass('open')
      }else{
          $(this).removeClass('open')
      }

      $(this).siblings('.body').slideToggle() 

      accordion.find('.body.in-view').removeClass('in-view')

      
      $(this).removeClass('start')
      
  })
  // Colow Swatch handler for 'product-template-v2.liquid'
  // On color swatch clicked, set the right slick slide
//   $('.color-picker__color input').on('change', function(){
//       const selected_color = $(this).attr("data-index");
//       const selected_name = $(this).attr("data-name");
//       const selected_variant_id = $(this).attr("data-variant-id");
//       var slider_index = parseInt($('#color-'+selected_color).attr('data-slick-index'));
//       $('.product-offer__slider .main-slider').slick('slickGoTo', slider_index);
//       $('.color-selected').html(selected_name);
//       $('.btn.atc').prop('href', '/cart/add?id='+selected_variant_id);
//       var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + selected_variant_id;
//       window.history.replaceState({path: newurl}, '', newurl);
//   })

  // Color Swatch handler 'page-product-sections-template.liquid'
  // Product with sections - On color swatch clicked, set the right slick slide
$('.color-picker__color input').on('change', function () {

    const parent = $(this).closest('.color-picker__color');

    const selected_color_image_id = $(this).attr("data-image-id");
    const selected_name = $(this).attr("data-name");
    const selected_variant_id = $(this).attr("data-variant-id");
    const selected_qty = parseInt(parent.attr("data-qty"));

    const slider_index = $(`.slick-slide[data-image-id="${selected_color_image_id}"]`)
        .attr('data-slick-index');

    $('.product-offer__slider .main-slider').slick('slickGoTo', slider_index);
    $('.color-selected').html(selected_name);

    // ----- INVENTORY LOGIC -----
    if (!selected_qty || selected_qty <= 0) {

        $('.btn.atc')
            .text('Sold Out')
            .addClass('disabled')
            .css('pointer-events', 'none')
            .prop('href', '#');

        $('.color-way-qty').hide(); // ← hide when out of stock

    } else {

        $('.btn.atc')
            .text('Add to Cart')
            .removeClass('disabled')
            .css('pointer-events', 'auto')
            .prop('href', '/cart/add?id=' + selected_variant_id);

        $('.color-way-qty')
            .text(`Only ${selected_qty} Left`)
            .show(); // ← show when in stock
    }

    const newurl =
        window.location.protocol + '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' + selected_variant_id;

    window.history.replaceState({ path: newurl }, '', newurl);
});



  $('.tech .heading').on('click', function(){
      if($(this).attr('data-image')){
          var side_image = $(this).attr('data-image')
          console.log(side_image)
          $('.tech:not(.works) .tech__image img').prop('src', side_image)
      }
  })

  // new landing page js start
  $('.video-slider__contents').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '30%',
    arrows: false,
    dots: true,
    autoplay: false,
    initialSlide: 1,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                centerPadding: '20%',
            }
        },
        {
            breakpoint: 768,
            settings: {
                centerPadding: '0',
            }
        },
    ]
});
    $('.marquee-bar__contents').slick({
        speed: 6000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: 'linear',
        slidesToShow: 1,
        draggable:false,
        focusOnSelect:false,
        pauseOnFocus:false,
        pauseOnHover:false,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
    });
    $('.info-slider__content').slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        adaptiveHeight: true
    });
    $('.usp-carousel__content').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: false,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
    });
    $('.zoho-form__carousel-contents').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    autoplay: true,
    vertical: true,
    centerPadding: "60px",
    centerMode: true,
    });
    // new landing page js end

    $('.review-slider__contents').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: false,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 525,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

  /* FAQS */
  $('.faq-block').on('click', (event)=>{
      const faq_block = event.currentTarget;
      // if open, close
      if(faq_block.classList.contains('open')){
          $('.faq-answer', faq_block).slideUp();
          faq_block.classList.remove('open');
      }
      else {
          // else, open
          $('.faq-answer', faq_block).slideDown();
          faq_block.classList.add('open');
      }
      

  })

  /* Play Video on click*/
  $('.m3-custom-video .video__button-wrapper').on('click', (event)=>{
      event.preventDefault();
      const $button = event.currentTarget;
      const video = $($button).prev('video')[0];
      console.log(video)

      if(video.classList.contains('playing')){
          video.pause()
          video.classList.remove('playing')
          console.log("Play - Stop")
      }else{
          video.play();
          video.classList.add('playing')
          video.setAttribute('controls', true);
          console.log("playing")
      }
  })

  /* Counter Up */
  if(window.counterUp){

    const counterUp = window.counterUp.default;

    const callback = entries => {
        entries.forEach( entry => {
            const el = entry.target
            if ( entry.isIntersecting && ! el.classList.contains( 'is-visible' ) ) {
                counterUp( el, {
                    duration: 1000,
                    delay: 10,
                } )
                el.classList.add( 'is-visible' )
            }
        } )
    }

    const IO = new IntersectionObserver( callback, { threshold: 1 } )

    const counters = document.querySelectorAll('.counter-enabled');
    counters.forEach( (counter) => {
        IO.observe( counter );
    })
    }

    // masseuse-discount
    $('.minimal-header__announcement-wrapper, .banner-marquee__announcement-wrapper').slick({
        speed: 10000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: 'linear',
        slidesToShow: 1,
        draggable:false,
        focusOnSelect:false,
        pauseOnFocus:false,
        pauseOnHover:false,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 5,
        arrows: false,
        buttons: false
      });
  
    // read more / read less
    var paragraphCount = $('.product-description > p').length;
    $('#hider').hide();
    $('#shower').hide();
    if (paragraphCount > 3) {
        $('#shower').show();
    }
    $( '#hider' ).click(function() {
        $('.product-description p:gt(1)').hide();
        $('#hider').hide();
        $('#shower').show();
    });
    $( '#shower' ).click(function() {
        $('.product-description p').show();
        $('#shower').hide();
        $('#hider').show();
    });
    $('.product-description p:gt(1)').hide();
}) 